import { ICredential } from '@commenda/types/src/credential/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useCredential(
  credentialId: string,
  {
    includeSecret = false,
    includeRegistrations = false,
  }: {
    includeSecret?: boolean;
    includeRegistrations?: boolean;
  } = {}
) {
  const queryString = [
    includeSecret ? 'includeSecrets=true' : '',
    includeRegistrations ? 'includeRegistrations=true' : '',
  ]
    .filter(Boolean)
    .join('&');

  const URL = `credentials/${credentialId}?${queryString}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: { credential: ICredential };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    credentialId ? URL : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
